import { render, staticRenderFns } from "./SimcardsStats.vue?vue&type=template&id=0ab6983b&scoped=true&"
import script from "./SimcardsStats.vue?vue&type=script&lang=js&"
export * from "./SimcardsStats.vue?vue&type=script&lang=js&"
import style0 from "./SimcardsStats.vue?vue&type=style&index=0&id=0ab6983b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab6983b",
  null
  
)

export default component.exports